import * as React from "react";
import { connect } from "react-redux";
import Modal from "../Modal";

import globalAction from '../../actions/global';
import { isPc } from "../../utils/util";

class MyGiftModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    
    componentDidMount() {
        
    }
    __onLoginOk(_username) {
        const { onLoginOk } = this.props;
        onLoginOk && onLoginOk(_username);
    }
    __onClose() {
        const {onClose} = this.props;
        onClose && onClose();
    }
    __handleSubmitAddr(drawRecordId) {
        const { submitAddr, setPhoneDrawRecordId } = this.props;
        submitAddr && submitAddr();
        // 手机的中奖id
        setPhoneDrawRecordId(drawRecordId);
    }
    renderContent(value, url) {
        let content = '';
        switch(value) {
            case 1:
                content = <img src={url} alt=""/>;
                break;
            case 2:
                content = <div className="m-myRecord-item__hdText"><span>8</span>元</div>;
                break;
            case 3:
                content = <div className="m-myRecord-item__hdText"><span>6</span>个月</div>;
                break;
            case 4:
                content = <div className="m-myRecord-item__hdText"><span>1</span>年</div>;
                break;
            case 5:
                content = <div className="w-mobile-pic"></div>;
                break;
            default:
                break;
        }
        return content;
    }
    renderName(data) {
        const {prizeId, name} = data;
        let content = '';
        switch(prizeId) {
            case 2:
            case 3:
            case 4:
                content = 'VIP邮箱服务期';
                break;
            case 1:
            case 5:
            default:
                content = name;
                break;
        }
        return content;
    }
    renderDesc(data) {
        let content = '';
        switch(data.prizeId) {
            case 1:
                content = <p>微信扫码，添加班主任<br/>备注活动VIP帐号，即可入学</p>;
                break;
            case 2:
            case 3:
            case 4:
                content = <p>已加帐号上<br/>可在邮箱「个人中心」查看</p>
                break;
            case 5:
                content = <button className="w-button" onClick={() => {this.__handleSubmitAddr(data.drawRecordId)}}>填写收货地址</button>
                break;
            default:
                break;
        }
        return content;
    }
    render() {
        const {isOpen, records, toggleMyPrizesModal} = this.props;
        let title = '';
        if (records.length > 0) {
            title = '我的礼品'
        }
        return (
            <Modal isOpen={isOpen} title={title} className="w-records-modal" onClose={this.__onClose.bind(this)}>
                {
                    records.length > 0 ?
                        <div className="m-records-wrap">
                            {
                                records.map((item, index) => {
                                    return (<div className="m-myRecord-item" key={index}>
                                        <div className="m-myRecord-item__hd">
                                            {this.renderContent(item.prizeId, item.picture)}
                                        </div>
                                        <div className="m-myRecord-item__name">{this.renderName(item)}</div>
                                        <div className="m-myRecord-item__desc">
                                            {this.renderDesc(item)}
                                        </div>
                                    </div>)
                                })
                            }
                        </div>
                        :
                        <div className="m-records-empty-wrap">
                            <div className="m-records-empty-text">您尚未获得翻牌礼品，{!isPc() && <br/>}快去翻牌吧！</div>
                            <div className="m-records-empty-btn"><button className="w-button" onClick={()=> {toggleMyPrizesModal(false)}}>去翻牌</button></div>
                        </div>
                }
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        records: state.global.records,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setPhoneDrawRecordId(id) {
            dispatch(globalAction.setPhoneDrawRecordId(id));
        },
        toggleMyPrizesModal(flag) {
            dispatch(globalAction.toggleMyPrizesModal(flag));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyGiftModal);
